class SliderImageGalleryFull {
    constructor() {
        this.name = 'slider-image-gallery-full';
        this.components = document.querySelectorAll(`.${this.name}`);

        if (this.components) {
            this.init();
        }
    }

    init() {
        this.components.forEach((comp) => {
            let sliderNode = comp.querySelector('.splide');
            if (!sliderNode) return;
            this.initSlider(sliderNode);
        });
    }

    initSlider(slider) {
        let sets = slider.closest(`.${this.name}`);
        let isOnlyOne = slider.querySelectorAll(".splide__slide").length <= 1;

        this.setStates(slider);

        const sliderNode = new Splide(slider, {
            type: sets.dataset.type === "true" ? 'loop' : 'slide',
            autoplay: sets.dataset.autoplay,
            speed: parseInt(sets.dataset.speed) || 400,
            interval: parseInt(sets.dataset.interval) || 5000,
            start: 0,
            drag: !isOnlyOne,
            pagination: false
        });

        sliderNode.on('mounted', () => {
            let slide = sliderNode.Components.Slides.getAt(0).slide;
            this.everyoneOnPause(slider);
            this.handleVideoAudio(slide);
        });

        sliderNode.on('move', newIndex => {
            let slide = sliderNode.Components.Slides.getAt(newIndex).slide;
            this.everyoneOnPause(slider);
            this.handleVideoAudio(slide);
        });

        sliderNode.mount();
    }

    handleVideoAudio(slide) {
        let video = slide.querySelector('video');
        if (video) {
            this.playVideo(video);
        }
    }

    playVideo(video) {
        if (video.dataset.muted === "false") video.muted = false;
        if (video.dataset.paused === "false") video.play();
    }

    pauseVideo(video) {
        video.muted = true;
        video.pause();
    }

    setStates(slider) {
        let sliderItems = slider.querySelectorAll(".splide__slide");
        if (sliderItems.length) {
            Array.from(sliderItems).forEach(slide => {
                let video = slide.querySelector('video');
                if (video) {
                    video.dataset.muted = video.muted ? "true" : "false";
                    video.dataset.paused = video.autoplay ? "false" : "true";
                }
            });
        }
    }

    everyoneOnPause(slider) {
        let sliderItems = slider.querySelectorAll(".splide__slide");
        if (sliderItems.length) {
            Array.from(sliderItems).forEach(slide => {
                let video = slide.querySelector('video');
                if (video) this.pauseVideo(video);
            });
        }
    }
}

const sliderImageGalleryFull = new SliderImageGalleryFull();
